import * as React from 'react';
import styled from 'styled-components';

import Colors from '../../lib/Colors';
import Reward from '../../lib/types/Reward';
import SmilesIcon from '../icons/SmilesIcon';

interface IProps {
  reward: Reward;
  onClick: () => void;
  isSelected: boolean;
  isFavorited: boolean;
  isAuthenticated: boolean;
  userCredits: number;
  userVipCredits: number;
  className?: string;
}

function UnstyledRewardButton(props: IProps) {
  let rebateBadge = null;
  const { previousAmount, amount, name, vipAmount } = props.reward;
  if (previousAmount) {
    const rebate = Math.ceil(100 * (1 - (amount / previousAmount)));
    rebateBadge = <div className="rebate-badge">-{rebate}%</div>;
  }
  const className = [
    props.className,
    props.isFavorited && 'is-favorited',
    props.isSelected && 'is-selected',
    (!props.isAuthenticated || !(props.userCredits >= amount)
        || !(props.userVipCredits >= vipAmount)) && 'is-not-available',
  ].filter(Boolean).join(' ');

  return (
    (
      <button
        onClick={props.onClick}
        className={className}>
        <header>
          {name}
          {rebateBadge}
        </header>
        <footer>
          <div>
            {amount.toLocaleString()} <SmilesIcon />
          </div>
          {previousAmount && (
            <div className="previous-amount">
              {previousAmount.toLocaleString()} <SmilesIcon />
            </div>
          )}
        </footer>
      </button>
    )
  );
}

const RewardButton = styled(UnstyledRewardButton)`
  display: flex;
  flex-direction: column;
  max-width: 10rem;
  border: none;
  outline: none;
  padding: 0;
  transition: transform 0.3s ease-out;
  transform: ${(p: IProps) =>
    p.isSelected ? 'scale3d(1, 1, 1)' : 'scale3d(.9, .9, .9)'};
  color: #333;
  &.is-not-available {
    color: ${Colors.notAvailable};
    header {
      border: 1.5px solid ${Colors.notAvailable};
    }
    footer svg path {
      fill: ${Colors.notAvailable};
    }
  }
  &.is-selected {
    color: ${Colors.primary};
    header {
      border: 1.5px solid ${Colors.primary};
    }
    footer svg path {
      fill: ${Colors.primary};
    }
  }
  &.is-favorited {
    color: ${Colors.highlight}!important;
    header {
      border: 1.5px solid ${Colors.highlight}!important;
    }
    footer svg path {
      fill: ${Colors.highlight}!important;
    }
  }

  background-color: white;

  header {
    font-size: ${(p: IProps) =>
      p.reward.name.length < 6 ? '1.75rem' : '1rem'};
    font-weight: ${(p: IProps) =>
      p.reward.name.length < 6 ? '500' : 'normal'};
    margin: 0 0 0.25rem 0;
    padding: ${(p: IProps) => (p.reward.name.length < 6 ? '1rem' : '.25rem')};
    border: 1.5px solid #333;
    border-radius: 0.25rem;
    min-height: 2rem;
    display: flex;
    flex-direction: row;
    align-items: center;

    .rebate-badge {
      position: absolute;
      right: -1rem;
      top: -0.5rem;
      padding: 0.25rem 0.5rem;
      border-radius: 0.75rem;
      line-height: 1;
      font-size: 0.8rem;
      font-weight: bold;
      color: white;
      background-color: ${Colors.badgeBackground};
    }
  }

  footer {
    min-height: 2rem;
    svg path {
      fill: #333;
      transition: fill 0.3s ease-out;
    }

    .previous-amount {
      opacity: 0.5;
      text-decoration: line-through;
      font-size: 0.7rem;
      svg {
        width: 0.5rem;
        height: 0.5rem;
      }
    }
  }
`;

export default RewardButton;



// WEBPACK FOOTER //
// ./src/components/SingleRewardCategoryView/RewardButton.tsx